import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../reducers/index"
import { searchFilterReducerSlice } from "../reducers/searchFilterSlice";
import { ERROR, SOMETHING_WENT_WRONG } from "../../utils/constants";
import AddAlertMessage from "../../components/alert/Alert";
import { postInfoSlice } from "../reducers/postInfoSlice";

const store = configureStore({
  reducer: rootReducer,
});

export const resetAllAction = () => (dispatch) => {
  try {
    dispatch(searchFilterReducerSlice.actions.reset());
    dispatch(postInfoSlice.actions.reset())
  } catch (error) {
    AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
  }
};

export default store;
